//Generated File 
export default class ExpressionRelationship{
	static readonly AND = `AND`;
	static readonly OR = `OR`;
}
